import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.0613 3.25067C14.5561 3.79993 15.2607 4.11352 16 4.11352C16.7393 4.11352 17.4439 3.79993 17.9387 3.25067L19.2 1.86667C19.9407 1.04686 21.1172 0.781815 22.1379 1.20478C23.1587 1.62774 23.8029 2.6472 23.7467 3.75067L23.652 5.61734C23.615 6.3537 23.891 7.07139 24.412 7.59311C24.933 8.11484 25.6502 8.39195 26.3867 8.356L28.2533 8.26134C29.3561 8.20697 30.3739 8.85181 30.7957 9.87209C31.2176 10.8924 30.9524 12.0677 30.1333 12.808L28.744 14.0613C28.1954 14.5568 27.8824 15.2615 27.8824 16.0007C27.8824 16.7399 28.1954 17.4445 28.744 17.94L30.1333 19.1933C30.9531 19.9341 31.2182 21.1105 30.7952 22.1313C30.3723 23.152 29.3528 23.7962 28.2493 23.74L26.3827 23.6453C25.6446 23.6074 24.9251 23.884 24.4025 24.4065C23.88 24.9291 23.6034 25.6486 23.6413 26.3867L23.736 28.2533C23.7849 29.351 23.1417 30.3619 22.1267 30.7826C21.1117 31.2032 19.9419 30.9437 19.2 30.1333L17.9453 28.7453C17.4501 28.1968 16.7457 27.8838 16.0067 27.8838C15.2677 27.8838 14.5632 28.1968 14.068 28.7453L12.808 30.1333C12.0672 30.9476 10.8954 31.21 9.87806 30.7895C8.86072 30.3689 8.21626 29.3557 8.26667 28.256L8.36267 26.3893C8.40063 25.6513 8.12402 24.9318 7.60147 24.4092C7.07891 23.8866 6.35936 23.61 5.62133 23.648L3.75467 23.7427C2.65164 23.8002 1.63175 23.1574 1.20784 22.1375C0.78394 21.1176 1.04777 19.9412 1.86667 19.2L3.25467 17.9467C3.80323 17.4512 4.11629 16.7465 4.11629 16.0073C4.11629 15.2681 3.80323 14.5635 3.25467 14.068L1.86667 12.808C1.05052 12.0677 0.787078 10.8946 1.2083 9.8764C1.62952 8.85818 2.64468 8.21406 3.74533 8.26667L5.612 8.36134C6.35146 8.40021 7.07264 8.12325 7.59598 7.59939C8.11933 7.07554 8.3956 6.35409 8.356 5.61467L8.26667 3.74667C8.21505 2.6465 8.85909 1.63216 9.87672 1.21089C10.8944 0.789612 12.0669 1.05193 12.808 1.86667L14.0613 3.25067Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 22.0013C19.3137 22.0013 22 19.315 22 16.0013C22 12.6876 19.3137 10.0013 16 10.0013C12.6863 10.0013 10 12.6876 10 16.0013C10 19.315 12.6863 22.0013 16 22.0013Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSettings);
export default ForwardRef;
